exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-body .star[data-v-80868fd6] {\n  margin-bottom: 18px;\n}\n.panel-body .star[data-v-80868fd6]:last-child {\n  margin-bottom: 0;\n}\n.panel-body .rating-metrics .label[data-v-80868fd6] {\n  min-width: 35px;\n}\n.panel-body .rating-metrics .label .bar-item[data-v-80868fd6]:first-child {\n  margin-top: 0;\n}\n.panel-body .rating-metrics .label .bar-item[data-v-80868fd6]:last-child {\n  margin-bottom: 0;\n}\n", ""]);

// exports
